export class AuthenticationReq {
    subject?: string;
    phone?: string;
    email?: string;
    username?: string;
    password?: string;
    mobileNo?: string;
    createdUser?: string;
    role?: string;
    roleId?: number;
    sEmailVerified?: boolean;
    noOfFailedLogin?: number;
    accountLockedOn?: string;
    sentOtp?: string;
    otpSentTime?: string;
    otpExpiryTime?: string;
    salt?: string;
    hashedRefreshToken?: string;
    confirmPassword?: string;
    id?: number;

    constructor(
        subject?: string,
        phone?: string,
        email?: string,
        username?: string,
        password?: string,
        mobileNo?: string,
        createdUser?: string,
        role?: string,
        roleId?: number,
        sEmailVerified?: boolean,
        noOfFailedLogin?: number,
        accountLockedOn?: string,
        sentOtp?: string,
        otpSentTime?: string,
        otpExpiryTime?: string,
        salt?: string,
        hashedRefreshToken?: string,
        confirmPassword?: string,
        id?: number,
    ) {
        this.subject = subject
        this.phone = phone
        this.email = email
        this.username = username
        this.password = password
        this.mobileNo = mobileNo
        this.sEmailVerified = sEmailVerified
        this.noOfFailedLogin = noOfFailedLogin
        this.accountLockedOn = accountLockedOn
        this.sentOtp = sentOtp
        this.otpSentTime = otpSentTime
        this.otpExpiryTime = otpExpiryTime
        this.salt = salt
        this.hashedRefreshToken = hashedRefreshToken
        this.confirmPassword = confirmPassword
        this.createdUser = createdUser
        this.role = role
        this.roleId = roleId
        this.id = id

    }

}